<template>
  <div>
    <p class="sw-intro">
      <template v-if="esProfesional">{{ t('Indique los datos de su cliente tal y como figuran en su documento de identidad.') }}</template>
      <template v-else>{{ t('Escriba sus datos tal y como figuran en su documento de identidad.') }}</template>
    </p>
    <p class="sw-ayuda sw-ayuda--doc">
      {{ t('Para firmar en la notaría hará falta el original en vigor del DNI, pasaporte, tarjeta de residencia (TIE) o documento de identidad de un país de la UE/EEE. El carnet de conducir no sirve.') }}
    </p>
    <SolicitudPersonaCampos
      :persona="estado.solicitante"
      prefijo="solicitante"
      :roles="tipo?.roles ?? []"
      :etiqueta-rol="esProfesional ? 'Papel de su cliente' : 'Su papel en la operación'"
      :contacto-obligatorio="!esProfesional"
    />
    <p v-if="!esProfesional" class="sw-ayuda">
      <template v-if="conNV">{{ t('Le enviaremos a este email la confirmación y el acceso para seguir su encargo en la Notaría Virtual.') }}</template>
      <template v-else-if="config.EnviarCopiaCliente">{{ t('Le enviaremos a este email la confirmación de su encargo.') }}</template>
      <template v-else>{{ t('La notaría usará estos datos para contactarle.') }}</template>
    </p>
  </div>
</template>

<script setup lang="ts">
import { t } from '../../composables/solicitudTextos'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
const { estado, tipo, esProfesional, config, conNV } = useSolicitudWeb()
</script>
